<script setup lang="ts">
const { state: sharedFolderState } = useSharedFolders()
const { sidebarSharedFoldersId } = useGlobals()
</script>

<template>
  <sidebar-section :id="sidebarSharedFoldersId">
    <template #label>
      Shared Folders
    </template>
    <template #actions>
      <dropdown
        v-model:active="sharedFolderState.new.dialogOpen"
        anchor-x="left"
        anchor-y="top"
        flow-x="right"
        flow-y="down"
      >
        <template #default="{ open }">
          <button class="add" @click="open()">
            <icon-action type="plus" size="xs" />
          </button>
        </template>
        <template #menu>
          <sidebar-shared-folders-create-dropdown class="creation-dropdown" />
        </template>
      </dropdown>
    </template>
    <template #default>
      <div class="shared-folders">
        <sidebar-entry-shared-folder
          v-for="{ home, archive }, sharedFolderId in sharedFolderState.all"
          :key="sharedFolderId"
          :home
          :archive
          :shared-folder-id
        />
      </div>
    </template>
  </sidebar-section>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.add
  @apply -mr-1 text-t-header-info px-1 py-0.5 rounded-sm cursor-pointer
  &:hover
    @apply bg-[#{$sidebar-bg-item-hovered}] text-[#{$global-t-default}]

.shared-folders
  @apply flex flex-col gap-[#{$sidebar-gap-items-container}]

.creation-dropdown
  @apply
</style>
